import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TopBar } from '../components/ui/TopBar';
import { IconButton } from '../components/ui/IconButton';
import { Card } from '../components/ui/Card';

export function ResetSecurity() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen overflow-x-hidden" style={{ background: '#010713' }}>
      <div className="relative mx-auto w-full max-w-[430px] min-h-screen">
        <TopBar
          left={
            <IconButton aria-label={t('common.back', '返回')} onClick={() => navigate(-1)}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 18l-6-6 6-6" />
              </svg>
            </IconButton>
          }
          title={t('resetSecurity.title', '重設密保')}
        />

        <div className="flex flex-col items-center justify-center px-5 pt-24 gap-4">
          <Card className="w-full px-6 py-10 flex flex-col items-center gap-3 text-center">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth={1.4} className="text-brand-400 opacity-60">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            <p className="text-base font-semibold text-text-primary">
              {t('common.comingSoon', 'Coming Soon')}
            </p>
            <p className="text-sm text-text-muted">
              {t('common.comingSoonSub', '即將推出')}
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default ResetSecurity;
